import type { SVGProps } from 'react';
import * as React from 'react';
import { forwardRef, Ref } from 'react';

const SvgTgeDeposit = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 40 40"
    ref={ref}
    {...props}
  >
    <g fill="#E2E2E2" filter="url(#tge-deposit_svg__a)">
      <path d="M29.979 8a2.3 2.3 0 0 1 2.297 2.298V21.86a5.9 5.9 0 0 0-2.298-.465c-3.172 0-5.744 2.5-5.744 5.582q.001.574.115 1.116H9.298A2.3 2.3 0 0 1 7 25.795V10.298A2.3 2.3 0 0 1 9.298 8zm-18.383 6.697c-.635 0-1.149.515-1.149 1.15v5.515a1.149 1.149 0 1 0 2.298 0v-5.515a1.15 1.15 0 0 0-1.15-1.15m7.468 0c-2.221 0-4.021 1.75-4.021 3.908s1.8 3.907 4.02 3.907c2.221 0 4.022-1.75 4.022-3.907s-1.8-3.908-4.021-3.908" />
      <path d="M31.127 24.465v4.676l1.401-1.361a.88.88 0 0 1 1.219 0 .82.82 0 0 1 0 1.184l-2.872 2.79a.87.87 0 0 1-.61.246.87.87 0 0 1-.609-.245l-2.872-2.791a.82.82 0 0 1 0-1.184.88.88 0 0 1 1.218 0l1.402 1.361v-4.676a.85.85 0 0 1 .861-.837.85.85 0 0 1 .862.837" />
    </g>
    <defs>
      <filter
        id="tge-deposit_svg__a"
        width={27}
        height={26}
        x={7}
        y={8}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={1} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.333333 0 0 0 0 0.333333 0 0 0 0 0.333333 0 0 0 0.25 0" />
        <feBlend in2="shape" result="effect1_innerShadow_141_25254" />
      </filter>
    </defs>
  </svg>
);
const ForwardRef = forwardRef(SvgTgeDeposit);
export default ForwardRef;
